import React, { useState, useEffect } from 'react';

import { useAppContext, useFreecodeContext } from 'hooks/useContext';
import { FreecodePlayer } from 'components/FreecodePlayer/freecodePlayer';
import { executorDecompress } from 'functions/executorDecompress';

export default function FreecodeCanvas() {
  const { isDarkMode } = useAppContext();
  const { testImpl } = useFreecodeContext();

  const [peekData, setPeekData] = useState(undefined);

  useEffect(() => {
    let data = executorDecompress(testImpl.generated?.peekResponse);
    data = data.slice(0, testImpl.configLevels.numPublic);
    setPeekData(data);
  }, [testImpl.generated, testImpl.configLevels, setPeekData]);

  return <FreecodePlayer testImplementation={testImpl} levels={peekData} isDarkMode={isDarkMode} sizeLimitByParent />;
}
